import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { Footer } from "@/components/Footer";
import { useSeo } from "@/lib/useSeo";
import { hotelierLogin, hotelierMe } from "@/lib/api";

export default function HotelierLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  useSeo({
    title: "Accesso Hotelier — SuiteCrowd",
    description: "Accedi al portale gestione hotel di SuiteCrowd.",
  });

  useEffect(() => {
    hotelierMe().then(() => navigate("/hotelier/dashboard", { replace: true })).catch(() => {});
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await hotelierLogin(form);
      navigate("/hotelier/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white text-[#121212] flex flex-col">
      <nav className="border-b border-[#E5E5E5]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex justify-between items-center">
          <Logo variant="dark" size="md" />
          <Link to="/" className="text-[11px] tracking-[0.24em] uppercase text-neutral-500 hover:text-[#121212] transition-colors">
            Home
          </Link>
        </div>
      </nav>

      <section className="flex-1 flex items-center px-6 md:px-12 py-20">
        <div className="max-w-md w-full mx-auto">
          <div className="sc-overline mb-4">Portale Hotelier</div>
          <h1 className="font-display font-light text-4xl mb-8" style={{ letterSpacing: "-0.03em" }}>
            Accedi
          </h1>
          <form data-testid="hotelier-login-form" onSubmit={submit} className="space-y-5">
            <div>
              <label className="sc-overline block mb-2">Email</label>
              <input required type="email" data-testid="login-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="sc-input-light" />
            </div>
            <div>
              <label className="sc-overline block mb-2">Password</label>
              <input required type="password" data-testid="login-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="sc-input-light" />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit" className="sc-btn-primary w-full">
              {loading ? "Accesso..." : "Entra"}
            </button>
            <div className="text-[11px] tracking-[0.2em] uppercase text-center text-neutral-500 pt-2">
              Nuovo su SuiteCrowd?{" "}
              <Link to="/proponi" className="hover:text-[#121212] transition-colors">
                Proponi il tuo hotel
              </Link>
            </div>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
}
